// extracted by mini-css-extract-plugin
export default {"home":"home__7jF75","cardHeader":"cardHeader__e7gVe","cardBody":"cardBody__qDbOj"};